import { useEffect, useState } from "react";

// Welle 5 Phase 3 — keyboard avoidance for the fullscreen AI modal.
// Tracks window.visualViewport (height shrinks when the on-screen
// keyboard opens on iOS/Android) so a fixed container can resize and
// keep its composer above the keyboard. `active=false` detaches all
// listeners.
export function useVisualViewport(active) {
  const [size, setSize] = useState({ height: null, offsetTop: 0 });

  useEffect(() => {
    if (!active) return undefined;
    const vv = window.visualViewport;
    if (!vv) return undefined;
    const update = () =>
      setSize({ height: Math.round(vv.height), offsetTop: Math.round(vv.offsetTop) });
    update();
    vv.addEventListener("resize", update);
    vv.addEventListener("scroll", update);
    return () => {
      vv.removeEventListener("resize", update);
      vv.removeEventListener("scroll", update);
      setSize({ height: null, offsetTop: 0 });
    };
  }, [active]);

  return size;
}
